/* eslint-disable no-shadow */
import { EfirmaUserType, RfcUserType } from 'Types/common';

export type SatProps = {
  setScreen: (value?: number) => void;
  satValues: RfcUserType;
  satEfirmaValues: EfirmaUserType;
  setSubContent: (value: boolean) => void;
  refetch: () => void;
};

export enum CredentialsType {
  EFIRMA = 'efirma',
  RFC = 'rfc',
}

export enum AccountQueryKey {
  GET_CLABE = 'getClabe',
  FETCH_SAT_USER_DATA = 'fetch_sat_stage_user',
  SAVE_EFIRMA_FORM = 'save_efirma_form',
}
